import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from '@souche-f2e/muji';
const TextCenter = styled.div `
  text-align: center;
  color: #fff;
`;
const Root = styled(TextCenter) `
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000537;
  .title {
    width: 100%;
    font-size: 64px;
  }
`;
const mapStateToProps = (rootState) => ({
    _state: rootState.screen,
});
class BeforeAuction extends Component {
    render() {
        return (<Root>
        <div className="position__Abs-center title">
          场次即将开始，敬请期待
        </div>
      </Root>);
    }
}
export default connect(mapStateToProps)(BeforeAuction);
